import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import forumViewSelector from 'Selectors/forumViewSelector';

import Forum from 'Components/forums/ForumComponent';
import ForumLink from 'Components/forums/ForumLinkComponent'
import AdComponent from 'Components/ads/AdComponent';

import { pathToForum } from 'Utils/nav/NavHelpers';
import { resetInfinite } from 'Actions/InfiniteScrollActions';
import { resetForum } from 'Actions/ForumviewActions';
import { resetThread } from 'Actions/ThreadviewActions';

class ForumListComponent extends React.Component {
	gotoForum = ( id ) => {
		this.props.dispatch( resetInfinite() );
		this.props.dispatch( resetForum() );
		this.props.dispatch( resetThread() );

		this.props.dispatch( push( pathToForum( id ) ) );
	};

	buildForum = ( forum ) => {
		const { forumId } = this.props.forumview,
			{ ustate } = this.props;

//		let isFirst = ( i === 0 && pageNum === 1 ); // Let's assume we want the first ad on the first page

		if (forum.id !== forumId) {
			if( forum.link ) {
				return (
					<li key={ forum.id }>
						<ForumLink forum={ forum }/>
					</li>
				)
			} else {
				return (
					<li key={ forum.id } onClick={ () => this.gotoForum( forum.id ) }>
						<Forum forum={ forum } ustate={ ustate } dispatch={ this.props.dispatch }/>
					</li>
				)
			}
		}
	};

	buildPage = ( pageNum ) => {
		const { entities, result } = this.props.forumview;

		let forums = result.forums.filter( e => entities.forums[ e ] && entities.forums[ e ].page === pageNum ),
			forumsList = forums.map( ( id, i ) => this.buildForum( entities.forums[ id ] ) );

		return (
			<ul key={pageNum} className={`scroll_page page_${pageNum}`}>
				{ forumsList }
			</ul>
		)
	};

	render() {
		const { entities: {forums}, result, forumId } = this.props.forumview;
		let forumListPage = null;
		let adUnitIncontent = ( typeof this.props.adUnitIncontent !== 'undefined' && this.props.adUnitIncontent );

		if( this.props.isScrolled ) { // if we use infiniteSroll build pages
			forumListPage = this.props.pages.map( ( pageNum ) => this.buildPage( pageNum ) );

		} else {
			let listForums = this.props.forumList || result.forums,
				isThePlaceForTheAd = listForums.length > 2 ? 1 : 0, // for > 2 subforums: after the second, otherwise after first
				forumList = listForums.map(
					(k, i) => {
						let the_forum,
							forum = forums[k];

						if (forum.id !== forumId) {
							if( forum.link ) {
								the_forum = [
									<li key={ i }>
										<ForumLink forum={ forum }/>
									</li>
								];
							} else {
								the_forum = [
									<li key={ i } onClick={ () => this.gotoForum(forum.id) }>
										<Forum forum={ forum } ustate={ this.props.ustate } dispatch={ this.props.dispatch }/>
									</li>
								];
							}
						}

						// if we are in the place where the ad needs to be, place it
						let adUnit = ( adUnitIncontent && i === isThePlaceForTheAd ) ? <AdComponent key={ `HomePage_In_Content_Ad_${ forum.id }` } adType="101" adName={ 'HomePage_In_Content_Ad_' + forum.id } tag="li" /> : '';

						if( adUnit ) {
							the_forum.push( adUnit );
						}

						return the_forum;
					}
			);

			forumListPage = <ul>{ forumList }</ul>
		}

		return (
			<div ref={ this.props.listRef } className="forums nolinks">
				{ forumListPage }
			</div>
		);
	}
}

ForumListComponent.propTypes = {
	dispatch: PropTypes.func.isRequired
};

export default connect( forumViewSelector )( ForumListComponent );



// WEBPACK FOOTER //
// ./src/components/forums/ForumListComponent.js